/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Irrigation_Run_Status_RunningInputs */

const vi_irrigation_run_status_running = /** @type {(inputs: Irrigation_Run_Status_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đang tưới`)
};

/**

* @param {Irrigation_Run_Status_RunningInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const irrigation_run_status_running = /** @type {((inputs?: Irrigation_Run_Status_RunningInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Irrigation_Run_Status_RunningInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_irrigation_run_status_running(inputs)
});